<template>
<div class="blackJackBg">
    <b-container>
        <b-row>
            <b-col cols="12">
                <h1 class="headingTop">CUT BLACKJACK! - DEALER STANDS ON 17</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" class="leftColumn">
                <h2 class="heading">PLAYER</h2>
                <br><br>
                <div class="deckOfCards" v-for="cards in playerCards" :key="cards">
                    <b-card class="deckOfCards">
                        <img class="cardImage" :src="cards.image" alt="">
                    </b-card>
                </div>
                <h2 class="valueOfCards">{{playerValue}}</h2>
                <br>
                <button @click="hit()" v-if="!gameEnded && gameStarted" class="hitButton">HIT</button>
                <button @click="stand()" v-if="!gameEnded && gameStarted" class="hitButton">STAND</button>

            </b-col>

            <b-col cols="6" class="rightColumn">
                <h2 class="heading">DEALER</h2>
                <br><br>
                <div class="deckOfCards" v-for="cards in dealerCards" :key="cards">
                    <b-card class="deckOfCards">
                        <img class="cardImage" :src="cards.image" alt="">
                    </b-card>
                </div>
                <h2 class="valueOfCards">{{dealerValue}}</h2>
            </b-col>

        </b-row>

        <b-row>
            <b-col cols="6">
                <h2 class="heading">BALANCE : {{cutBalance.toFixed(0)}}</h2>
                <br>
                <button @click="startGame(12)" class="hitButton" v-if="!gameStarted">BET 12 CUT</button>
                <button @click="startGame(48)" class="hitButton" v-if="!gameStarted">BET 48 CUT</button>
                <button @click="startGame(120)" class="hitButton" v-if="!gameStarted">BET 120 CUT</button>
            </b-col>
            <b-col cols="6">
                <h2 class="headingEnd">{{endGameMessage}}</h2>
            </b-col>
        </b-row>
    </b-container>

    <b-modal ref="my-modal" id="my-modal" title="VALUE OF ACE?" hide-header hide-footer>
        <h2>VALUE OF ACE?</h2>
        <br><br>
        <button @click="addValue(11)" class="my-4 choice">11</button>
        <h2>OR</h2>
        <button @click="addValue(1)" class="my-4 choice">1</button>
    </b-modal>

</div>
</template>

<script>
import Web3 from 'web3';
import axios from 'axios';
import newCut from '../../assets/contracts/newCut.json'

export default {
    data: function () {
        return {
            web3: '',
            walletAddress: '',
            walletBalance: '',

            databaseID: '',

            deckID: "",
            
            playerCards: [
                
            ],
            playerValue: 0,

            dealerCards: [

            ],
            dealerValue: 0,

            disableHit: false,
            gameEnded : false,
            gameStarted: false,
            hasAce: false,

            cutBalance: 0,
            betAmount: 1,

            endGameMessage: "",

        }
    },
    mounted()
    {
        this.LoadEthWallet();
    },
    methods:{
        async gatherInformation()
        {
            await axios.get('https://my-app-2-9xqlr.ondigitalocean.app/api/contacts')
            .then(response=> {
                for(var i=0; i<response.data.data.length; i++)
                {
                    if(response.data.data[i].address === this.walletAddress)
                    {
                        this.databaseID = response.data.data[i]._id;
                        this.cutBalance = Number(response.data.data[i].cutAmount);
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
        },
        async updateDBBalance()
        {
            
            await axios.put(`https://my-app-2-9xqlr.ondigitalocean.app/api/contacts/${this.databaseID}`, {address:this.walletAddress, cutAmount: this.cutBalance.toString()})
            .then(response=> {
                console.log(response)
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
            this.gatherInformation();
            
        },
        async addValue(value)
        {
            this.addPoints("player", value)
            this.$refs['my-modal'].hide();
        },
        async addPoints(whichPerson, value)
        {
            if(whichPerson === "player")
            {
                if(value === "JACK" || value === "QUEEN" || value === "KING")
                {
                    this.playerValue += 10
                }
                else if (value === "ACE")
                {
                    this.$refs['my-modal'].show();
                }
                else
                {
                    this.playerValue += Number(value);
                }
                
                if(this.playerValue > 21)
                { 
                    this.gameEnded = true;
                    this.gameStarted = false;
                    this.betAmount = 1;

                    this.endGameMessage = "YOU LOSE!";
                    this.updateDBBalance();
                    
                }
                else if(this.playerValue == 21)
                {
                    this.stand();
                }
            }
            else
            {
                if(value === "JACK" || value === "QUEEN" || value === "KING")
                {
                    this.dealerValue += 10
                }
                else if (value === "ACE" && this.dealerValue <= 10)
                {
                    this.dealerValue += 11
                }
                else if (value === "ACE" && this.dealerValue >= 11)
                {
                    this.dealerValue += 1
                }
                else
                {
                    this.dealerValue += Number(value);
                }
            }

        },
        async startGame(totalBet)
        {
            if(this.cutBalance >= totalBet)
            {
                this.playerCards = [];
                this.dealerCards = [];
                this.playerValue = 0;
                this.dealerValue = 0;
                this.disableHit = false;
                this.gameEnded = false;
                this.gameStarted = true;
                this.betAmount = totalBet;
                this.hasAce = false;
                this.cutBalance -= totalBet;
                this.updateDBBalance();
                this.endGameMessage = "";

                await axios.get('https://deckofcardsapi.com/api/deck/new/draw/?count=3')
                .then(response => {
                    this.deckID = response.data.deck_id;

                    this.playerCards.push(response.data.cards[0]);
                    this.addPoints("player", response.data.cards[0].value)

                    this.dealerCards.push(response.data.cards[1]);
                    this.addPoints("dealer", response.data.cards[1].value)

                    this.playerCards.push(response.data.cards[2]);
                    this.addPoints("player", response.data.cards[2].value)
                })
                .catch(function (error) {
                    
                    console.log(error);
                })
                .then(function () {
                    
                });
            }
            else
            {
                alert("You don't have enough!")
            }

        },
        async hit()
        {
            if(this.playerValue <= 20 && this.disableHit == false)
            {
                await axios.get(`https://deckofcardsapi.com/api/deck/${this.deckID}/draw/?count=1`)
                .then(response => {
                    this.playerCards.push(response.data.cards[0]);
                    this.addPoints("player", response.data.cards[0].value)
                })
                .catch(function (error) {
                    
                    console.log(error);
                })
                .then(function () {
                    
                });
            }
            
        },
        async stand()
        {
            const timer = ms => new Promise(res => setTimeout(res, ms))

            if(this.playerValue <= 21)
            {
                this.disableHit = true;
                while(this.dealerValue <= 16)
                {
                    await axios.get(`https://deckofcardsapi.com/api/deck/${this.deckID}/draw/?count=1`)
                    .then(response => {
                        this.dealerCards.push(response.data.cards[0]);
                        this.addPoints("dealer", response.data.cards[0].value)
                    })
                    .catch(function (error) {
                        
                        console.log(error);
                    })
                    .then(function () {
                        
                    });
                    await timer(1500);
                }

                if(this.dealerValue <= 21)
                {
                    if(this.playerValue > this.dealerValue)
                    {
                        this.endGameMessage = "YOU WIN!";
                        
                        this.cutBalance += (this.betAmount * 2);
                        this.updateDBBalance();
                        this.betAmount = 1;
                        this.gameEnded = true;
                    }
                    else if (this.playerValue < this.dealerValue)
                    {
                        this.endGameMessage = "YOU LOSE!";
                        this.updateDBBalance();
                        
                        this.betAmount = 1;
                        this.gameEnded = true;
                    }
                    else
                    {
                        this.endGameMessage = "TIE!";
                        this.cutBalance += this.betAmount;
                        this.updateDBBalance();
                        this.betAmount = 1;
                        this.gameEnded = true;
                    }
                }
                else
                {
                    this.endGameMessage = "YOU WIN!";
                    
                    this.cutBalance += (this.betAmount * 2);
                    this.updateDBBalance();
                    this.betAmount = 1;
                    this.gameEnded = true;
                }
                

            }
            else if(this.playerValue > 21)
            {
                this.endGameMessage = "YOU WIN!";
                
                this.cutBalance += (this.betAmount * 2);
                this.updateDBBalance();
                this.betAmount = 1;
            }
            else
            {
                this.endGameMessage = "YOU LOSE!";
                this.updateDBBalance();
                
                this.betAmount = 1;
            }

            this.gameStarted = false;

        },
        LoadEthWallet: function(){
            if (typeof window.ethereum !== 'undefined') 
            {
                this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                this.web3.eth.net.getNetworkType()
                .then(network=>{
                    if(network == "main")
                    {
                        this.web3.eth.requestAccounts()
                        .then(acc=>{
                            this.walletAddress = acc[0];
                            this.gatherInformation();
                            this.web3.eth.getBalance(this.walletAddress)
                            .then(balance=>{
                                this.walletBalance = this.web3.utils.fromWei(balance, "ether");  
                                
                            });
                        })
                        .catch(err=>{
                            console.log(err);
                        })                                   
                    }
                    else{
                        this.chainChange();
                    }          
                })
            }
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },
        
    },
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.loadTokenInfo();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.loadTokenInfo();
            })
            
          },
    },
}
</script>

<style scoped>
.heading
{
    color: white;
    margin-top: 5vh;
    font-size: 4vh !important;
}
.headingEnd
{
    color: red;
    margin-top: 5vh;
    font-size: 5vh !important;
}
.headingTop
{
    margin-top: 7vh;
    font-size: 4vh !important;
    color: white;
    margin-bottom: 10vh;
}
.valueOfCards
{
    color: white;
    margin-top: 5vh;
    font-size: 4vh !important;
}
.deckOfCards
{
    display: inline-block;
    background: transparent;
}
.cardImage
{
    display: inline-block;
    width: 10vh;
}
.rightColumn
{
    border-left: 2px solid gray;
}
.blackJackBg
{
    background: url("../../assets/casino/blackjack.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;

}


/* CSS */
.hitButton {
  appearance: button;
  background-color: #1899D6;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .8px;
  line-height: 20px;
  margin: 0;
  outline: none;
  overflow: visible;
  padding: 13px 16px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transform: translateZ(0);
  transition: filter .2s;
  vertical-align: middle;
  white-space: nowrap;
  width: 25%;
}

.hitButton:after {
  background-clip: padding-box;
  background-color: #1CB0F6;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  bottom: -4px;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

.hitButton:main,
.hitButton:focus {
  user-select: auto;
}

.hitButton:hover:not(:disabled) {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.hitButton:disabled {
  cursor: auto;
}



/* CSS */
.choice {
  background-color: #FFFFFF;
  border: 1px solid #222222;
  border-radius: 8px;
  box-sizing: border-box;
  color: #222222;
  cursor: pointer;
  display: inline-block;
  font-family: Circular,-apple-system,BlinkMacSystemFont,Roboto,"Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  outline: none;
  padding: 13px 23px;
  position: relative;
  text-align: center;
  text-decoration: none;
  touch-action: manipulation;
  transition: box-shadow .2s,-ms-transform .1s,-webkit-transform .1s,transform .1s;
  user-select: none;
  -webkit-user-select: none;
  width: auto;
}

.choice:focus-visible {
  box-shadow: #222222 0 0 0 2px, rgba(255, 255, 255, 0.8) 0 0 0 4px;
  transition: box-shadow .2s;
}

.choice:active {
  background-color: #F7F7F7;
  border-color: #000000;
  transform: scale(.96);
}

.choice:disabled {
  border-color: #DDDDDD;
  color: #DDDDDD;
  cursor: not-allowed;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Games/Blackjack.vue